import { gql } from '@apollo/client';

export default gql`
  query getNotificationTotals {
    getNotificationTotals {
      unread
      userId
      open
    }
  }
`;
